var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cookie-alert'),_vm._v(" "),(!_vm.hideScrollTop)?_c('scroll-to-top'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }